import React, { useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import PropTypes from "prop-types";
import UserPhoto from "../../../../components/user-photo/user-photo";
import "./admin-department-create-panel.scss";
import { OLD_UI_URL } from "../../../../services/api/api-client";

const AdminDepartmentFormRightColumnNew = ({
  handleChange,
  values,
  errors,
  setFieldValue,
  isEdit,
  onDepartmentPictureUploaded,
}) => {
  const uploadElement = useRef(null);
  const removeElement = useRef(null);

  const enterKeyPhotoSubmission = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      uploadElement.current.click();
    }
  };

  const enterKeyRemovePhotoSubmission = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      removeElement.current.click();
    }
  };

  return (
    <Form.Row className="right-row">
      <Form.Group className="picture">
        <UserPhoto
          key={values?.CompanyLogo}
          photoBase64={values?.PhotoAdded ? values?.DepartmentImageRaw : ""}
          photo={values?.PhotoAdded ? values?.CompanyLogo : ""}
          name={values?.CompanyLogo}
          className="picture-icon"
        />
        <div className="choose-department-img-btn-container">
          <Button
            className="btn-wide choose-img-button"
            onKeyDown={(keyEvent) => enterKeyPhotoSubmission(keyEvent)}
          >
            <Form.Control
              name="department-photo"
              id="department-photo"
              label="Upload Department Image"
              ref={(upload) => (uploadElement.current = upload)}
              className="upload-depratment-button"
              type="file"
              // Defensive client-side filter so the OS file picker only offers
              // formats the backend's System.Drawing.Image.FromStream (GDI+)
              // can decode. Must mirror the MIME allowlist enforced inside
              // `onDepartmentPictureUploaded` in admin-department-form-new.jsx.
              // SVG is intentionally excluded — GDI+ cannot decode vector XML.
              accept="image/png,image/jpeg,image/gif,image/bmp,image/tiff"
              onChange={(e) => {
                onDepartmentPictureUploaded(e).then((rt) => {
                  // rt is undefined when validation/conversion failed (an
                  // alert is already showing) — without this guard the
                  // rt.split() below throws a TypeError.
                  if (!rt) return;
                  setFieldValue("DepartmentImageRaw", rt);
                  setFieldValue("CompanyLogo", rt.split(",")[1]);
                  setFieldValue("PhotoAdded", true);
                });
              }}
            />
            <div className="label-no-spacing">
              {values?.PhotoAdded ? "Change Photo" : "Upload Department Logo"}
            </div>
          </Button>
          {values?.PhotoAdded && (
            <Button
              onKeyDown={(keyEvent) => enterKeyRemovePhotoSubmission(keyEvent)}
              ref={(remove) => (removeElement.current = remove)}
              className="btn-wide clear choose-img-button btn-outlined"
              onClick={(e) => {
                setFieldValue(
                  "DepartmentImageRaw",
                  OLD_UI_URL +
                    "ApplicationDocuments/Files/202006250401097067.png"
                );
                setFieldValue(
                  "CompanyLogo",
                  OLD_UI_URL +
                    "ApplicationDocuments/Files/202006250401097067.png"
                );
                setFieldValue("PhotoAdded", false);
              }}
            >
              Remove Photo
            </Button>
          )}
        </div>
      </Form.Group>
      <Form.Group className="department-exchange-server-enabled enable-super-admin-functionality">
        <Form.Label className="label">Exchange Server Enabled</Form.Label>
        <Form.Check
          id="IsAppointmentEnable"
          checked={values.IsAppointmentEnable}
          onChange={(e) => {
            handleChange(e);
            setFieldValue("IsAppointmentEnable", true);
          }}
          className="department-active-btn"
          type="checkbox"
          label="Enabled"
        />
        <Form.Check
          id="IsExchangeServerDisabled"
          checked={!values.IsAppointmentEnable}
          onChange={(e) => {
            handleChange(e);
            setFieldValue("IsAppointmentEnable", false);
          }}
          className="department-inactive-btn"
          type="checkbox"
          label="Disabled"
        />
      </Form.Group>
      <Form.Group className="department-server-username">
        <Form.Label className="label">Exchange Server Username</Form.Label>
        <Form.Control
          id="ExchangeServerUserName"
          name="ExchangeServerUserName"
          placeholder="Enter Exchange Server Username"
          value={values?.ExchangeServerUserName ?? ""}
          onChange={(e) => {
            handleChange(e);
          }}
          disabled={!values.IsAppointmentEnable}
        />
      </Form.Group>
      <Form.Group className="department-server-password">
        <Form.Label>Exchange Server Password</Form.Label>
        <Form.Control
          id="ExchangeServerPassword"
          name="ExchangeServerPassword"
          placeholder="Enter Exchange Server Password"
          value={values?.ExchangeServerPassword ?? ""}
          onChange={(e) => {
            handleChange(e);
          }}
          disabled={!values.IsAppointmentEnable}
        />
      </Form.Group>
      <Form.Group className="department-server-url">
        <Form.Label>Exchange Server URL</Form.Label>
        <Form.Control
          id="ExchangeServerURL"
          name="ExchangeServerURL"
          placeholder="Enter Exchange Server URL"
          value={values?.ExchangeServerURL ?? ""}
          onChange={(e) => {
            handleChange(e);
          }}
          disabled={!values.IsAppointmentEnable}
        />
      </Form.Group>
      {isEdit ? (
        <Form.Group className="enable-super-admin-functionality">
          <Form.Label className="label">Department Status</Form.Label>
          <Form.Check
            id="Active"
            checked={values.Active}
            onChange={(e) => {
              handleChange(e);
              setFieldValue("Active", true);
            }}
            className="department-active-btn"
            type="checkbox"
            label="Active"
          />
          <Form.Check
            id="IsInactive"
            checked={!values.Active}
            onChange={(e) => {
              handleChange(e);
              setFieldValue("Active", false);
            }}
            className="department-inactive-btn"
            type="checkbox"
            label="Inactive"
          />
          <Form.Control.Feedback type="invalid">
            {errors.Active}
          </Form.Control.Feedback>
        </Form.Group>
      ) : (
        <></>
      )}
    </Form.Row>
  );
};

AdminDepartmentFormRightColumnNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  onDepartmentPictureUploaded: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
};
export default AdminDepartmentFormRightColumnNew;
